/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Link } from 'react-router';
import { find } from 'lodash';
// import languages from 'languages';
// import classNames from 'classnames';
// import { preloadRequirement } from '../../../../utils/functions';
import { simpleNotification } from '../../../../utils/notifications';
// import QuestForm from '../../../forms/QuestForm';
// import QuestForm from '../../../forms/QuestFormNew';


import './TwitchDropEdit.scss';
import TwitchDropForm from "../../../forms/TwitchDropForm";
// import {getCCTwitchDrop} from "../../../../epics/commandCenterEpic";
// import {assignTwitchDropInfo} from "../../../../actions";

class TwitchDropEdit extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      game: null,
    };
  }

  UNSAFE_componentWillMount() {
    const { token } = this.props.auth;
    const { twitchDropId } = this.props.router.params;
    if (twitchDropId) {
      this.props.getCCTwitchDrop(twitchDropId, token);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { gameId } = nextProps.router.params;
console.log('nextProps',nextProps.commandCenter.twitchDrop.data,this.props.commandCenter.twitchDrop.isLoading,nextProps.commandCenter.twitchDrop.isLoading,this.props.commandCenter.twitchDrop.isUpdating,
    nextProps.commandCenter.twitchDrop.isUpdating,this.props.commandCenter.twitchDrop.isCreating,nextProps.commandCenter.twitchDrop.isCreating);
    // Find & save game
    if (nextProps.commandCenter.games.data.length > 0) {
      const game = find(nextProps.commandCenter.games.data, game => game.id === gameId);
      if (game) {
        this.setState({
          game,
        });
      }
    }

    if (this.props.commandCenter.twitchDrop.isLoading === true && nextProps.commandCenter.twitchDrop.isLoading === false &&
        this.props.commandCenter.twitchDrop.isUpdating === false && nextProps.commandCenter.twitchDrop.isUpdating === false &&
        this.props.commandCenter.twitchDrop.isCreating === false && nextProps.commandCenter.twitchDrop.isCreating === false) {
      console.log('assignTwitchDropInfo');
      if (!nextProps.commandCenter.twitchDrop.errors.hasError) {
        this.props.assignTwitchDropInfo(nextProps.commandCenter.twitchDrop.data);
      }
    }

    if (this.props.commandCenter.twitchDrop.isCreating === true && nextProps.commandCenter.twitchDrop.isCreating === false) {
      if (nextProps.commandCenter.twitchDrop.errors.hasError) {
        if (nextProps.commandCenter.twitchDrop.errors.code === 'E_TWITCH_DROP_SLUG_DUPLICATED') {
          simpleNotification({
            level: 'error',
            title: 'Twitch Drop Slug Duplicated.',
            message: nextProps.commandCenter.twitchDrop.errors.message,
          });
          //this.props.assignQuestSlugError(nextProps.commandCenter.twitchDrop.errors.message);
        }
      } else {
        simpleNotification({
          level: 'success',
          title: 'Twitch Drop Created.',
          message: 'Your twitch drop has been created successfully.',
        });
        this.props.router.push(`/admin/command-center/${gameId}/twitch-drop`);
      }
    }

    if (this.props.commandCenter.twitchDrop.isUpdating === true && nextProps.commandCenter.twitchDrop.isUpdating === false) {
      if (nextProps.commandCenter.twitchDrop.errors.hasError) {
        if (nextProps.commandCenter.twitchDrop.errors.code === 'E_TWITCH_DROP_SLUG_DUPLICATED') {
          simpleNotification({
            level: 'error',
            title: 'Twitch Drop Slug Duplicated.',
            message: nextProps.commandCenter.twitchDrop.errors.message,
          });
          //this.props.assignQuestSlugError(nextProps.commandCenter.twitchDrop.errors.message);
        }
      } else {
        simpleNotification({
          level: 'success',
          title: 'Twitch Drop Updated.',
          message: 'Your twitch drop has been updated successfully.',
        });
        this.props.router.push(`/admin/command-center/${gameId}/twitch-drop`);
      }
    }
  }

  onSubmit = (questFormInfo) => {
    const {
      auth: { token },
      router: { params: { gameId, twitchDropId } },
    } = this.props;

    console.log('表单提交时间字段:', questFormInfo,gameId,twitchDropId);

    // 时间处理：确保将本地时间转换为UTC格式提交
    const preparedInfo = { ...questFormInfo, game: gameId };

    // 这些时间转换移动到了CustomDateTimePicker组件内部进行
    // 确保传递给后端的是UTC格式的ISO字符串
    // 在CustomDateTimePicker中，用户选择时间时已经处理了从本地时区到UTC的转换

    if (!twitchDropId) {
      this.props.createCCTwitchDrop(preparedInfo, token);
    } else {
      this.props.updateCCTwitchDrop(twitchDropId, preparedInfo, token);
    }
  }

  render() {
    const {
      admin: {
        preSignedUrl,
      },
      auth,
      commandCenter: {
        adminActivityLogs,
        campaigns: { data: campaigns },
        games: { data: games },
        twitchDrop: {
          data: quest,
          isLoading,
        },
      },
      config: { rules: { data: configRules } },
      form: { twitchDropForm = {} },
      getQuest,
      removeIcon,
      requestUploadImageUrl,
      router: {
        location: { pathname },
        params: { gameId },
      },
      swapQuestStep,
      swapRequirements,
      titleSlugApply,
      updateTwitchDropForm
    } = this.props;
    const { twitchDropId } = this.props.router.params;
    const { game } = this.state;
    const questData = twitchDropId ? quest : null;
    console.log('twitchDropForm1',twitchDropForm?.values);
    return (
      <section className="CCTwitchDropEdit" style={{ display: isLoading }}>
        <div className="CCTwitchDropEdit_bar">
          <Link
            to={`/admin/command-center/${gameId}/twitch-drop`}
            activeClassName="active"
            href={`/admin/command-center/${gameId}/twitch-drop`}
          >
            <button className="CCTwitchDrop__back--btn CTAButton__purple">Back</button>
          </Link>
          {questData
            &&
            <h2>Quest Title: {questData.title}</h2>
          }
        </div>

        <div style={{ display: (isLoading) ? 'none' : 'block' }}>
          <TwitchDropForm
            adminActivityLogs={adminActivityLogs}
            campaigns={campaigns}
            auth={auth}
            configRules={configRules}
            game={game || {}}
            games={games}
            getQuest={getQuest}
            isLoading={isLoading}
            onSubmit={this.onSubmit.bind(this)}
            pathname={pathname}
            preSignedUrl={preSignedUrl}
            twitchDrop={questData}
            twitchDropForm={twitchDropForm}
            removeIcon={removeIcon}
            requestUploadImageUrl={requestUploadImageUrl}
            swapQuestStep={swapQuestStep}
            swapRequirements={swapRequirements}
            titleSlugApply={titleSlugApply}
            updateTwitchDropForm={updateTwitchDropForm}
          />
        </div>
        <div className="QuestLoading" style={{ display: (isLoading) ? 'block' : 'none' }}><i className="fa fa-spinner fa-spin fa-3x fa-fw" /></div>
      </section>
    );
  }
}

TwitchDropEdit.propTypes = {

};

export default TwitchDropEdit;
